import { api, staticApi } from "../../services";
import { $config } from "../../conf";
import $store from "../../store";
import store from "../../store";

export let agendaApi = {
  /**
   * 获取 大会议程 扫地僧列表
   * @returns {*}
   */
  getSweepingMonklist({ field, keyword }) {
    return api.request(
      //TODO 这里需要换成配置文件里的地址
      "/wphc/api/front/talk_list",
      {
        field: field,
        // sess: store.state["userInfo"]["token"].hwid,
        sess: store.state["userInfo"]["token"].smarketToken
          ? store.state["userInfo"]["token"].smarketToken
          : "",
        keyword: keyword,
      },
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }
    );
  },
  /**
   * 获取  我的预约列表
   * @returns {*}
   */
  getMyAppoint() {
    return api.request(
      "/wphc/api/front/user_appoint_list",
      {
        sess: store.state["userInfo"]["token"].smarketToken,
      },
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }
    );
  },

  /**
   * 获取  扫地僧日程
   * @returns {*}
   */
  getSweepingMonkSchedule({ id }) {
    return api.request(
      "/wphc/api/front/talk_schedule",
      {
        activity_id: id,
      },
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }
    );
  },
  /**
   * 获取  预约 扫地僧
   * @returns {*}
   */
  appoint_talk({ id }) {
    return api.request(
      "/wphc/api/front/appoint_talk",
      {
        schedule_id: id, //日程id
        question: "期望探讨的问题", //期望探讨的问题
        sess: store.state["userInfo"]["token"].smarketToken,
      },
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }
    );
  },
  /**
   * 获取  取消 预约 扫地僧
   * @returns {*}
   */
  cancel_appoint_talk({ id }) {
    return api.request(
      "/wphc/api/front/cancel_appoint",
      {
        sess: store.state["userInfo"]["token"].smarketToken,
        appointment_id: id,
      },
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }
    );
  },

  /**
   * 获取 大会议程 codelabs 列表
   * @returns {*}
   */
  getCodelabslist({ field = [] }) {
    return api.request(
      "/wphc/api/front/lab_list",
      {
        field: field,
        sess: store.state["userInfo"]["token"].smarketToken
          ? store.state["userInfo"]["token"].smarketToken
          : "",
      },
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }
    );
  },
  /**
   *  大会议程 收藏 codelabs
   * @returns {*}
   */
  collectLabs({ activity_id, collect }) {
    return api.request(
      "/wphc/api/front/collect_labs",
      {
        sess: store.state["userInfo"]["token"].smarketToken,
        activity_id: activity_id,
        collect: collect,
      },
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }
    );
  },
  /**
   *  大会议程 收藏 codelabs
   * @returns {*}
   */
  unCollectLabs() {
    return api.request(
      "/wphc/api/front/cancel_appoint",
      {
        field: ["AI"],
        sess: store.state["userInfo"]["token"].hwid,
      },
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }
    );
  },
  /**
   *  大会议程 获取收藏的 codelabs
   * @returns {*}
   */
  getMyCollectLabs() {
    return api.request(
      "/api/front/collect_labs",
      {
        sess: store.state["userInfo"]["token"].smarketToken,
      },
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }
    );
  },
  /**
   *  下载
   * @returns {*}
   */
  addDownload({ params }) {
    return api.request(
      "/wphc/api/front/add_download",
      {
        sess: store.state["userInfo"]["token"].smarketToken,
        ...params,
      },
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }
    );
  },

  /**
   *  获取我的收藏
   * @returns {*}
   */
  downloadList() {
    return api.request(
      "/wphc/api/front/download_list",
      {
        sess: store.state["userInfo"]["token"].smarketToken,
      },
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }
    );
  },
  /**
   *  扫地僧问卷收集
   * @returns {*}
   */
  answerQuestion({ activity_id, schedule_id, question }) {
    return api.request(
      "/wphc/api/front/question_talk",
      {
        sess: store.state["userInfo"]["token"].smarketToken,
        activity_id,
        schedule_id,
        question,
      },
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }
    );
  },

  /**
   *  获取是否允许推荐
   * @returns {*}
   */
  GetRecommend() {
    return api.request(
      "/partner/remind/GetRecommend",
      {
        sess: store.state["userInfo"]["token"].smarketToken,
      },
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }
    );
  },
  /**
   *  设置是否允许推荐
   * @returns {*}
   */
  Recommend({ type }) {
    return api.request(
      "/partner/remind/Recommend",
      {
        sess: store.state["userInfo"]["token"].smarketToken,
        type,
      },
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }
    );
  },
  /**
   *  获取推荐评分
   * @returns {*}
   */
  GetRecommendScore() {
    return api.request(
      "/partner/remind/GetRecommendScore",
      {
        sess: store.state["userInfo"]["token"].smarketToken,
      },
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }
    );
  },
  /**
   *  推荐评分
   * @returns {*}
   */
  RecommendScore({ score }) {
    return api.request(
      "/partner/remind/RecommendScore",
      {
        sess: store.state["userInfo"]["token"].smarketToken,
        score,
      },
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }
    );
  },
  /**
   *  设置直播状态
   *  status 1 直播中 2直播结束 3 回放中
   * @returns {*}
   */
  getLiveStatusByIds({ ids }) {
    return api.request(
      "/partner/vhall/status",
      {
        ids,
      },
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }
    );
  },
};
